import AuthService from '@/services/auth.service';

export const auth = {
  namespaced: true,

  state: {
    user: null
  },

  actions: {
    login({ commit, dispatch }, credentials) {
      return AuthService.login(credentials).then((user) => {

          dispatch('company/initCompaniesAvailable', null, {root: true});
          dispatch('role/initRolesAvailable', null, {root: true});

          commit('loginSuccess', user);
          if(user.locale) {
            dispatch('locale/setLocale', user.locale?.substring(0, 2), {root: true});
          }
          return Promise.resolve(user);
        }, (error) => {
          commit('logout');
          return Promise.reject(error);
        }
      );
    },

    logout({ commit }) {
      commit('logout');
    },

    setCompanySelected({ commit }, { idUser, idCompany }) {
      return AuthService.setCompanySelected(idUser, idCompany).then((user) => {
          commit('loginSuccess', user);
          return Promise.resolve(user);
        },
        (error) => {
          commit('logout');
          return Promise.reject(error);
        }
      );
    },

    setLanguageSelected({ commit, dispatch }, { idUser, locale }) {
      console.debug('Setting language to', locale);
      return AuthService.setLanguageSelected(idUser, locale).then((user) => {
          commit('loginSuccess', user);
          if(user.locale) {
            dispatch('locale/setLocale', user.locale?.substring(0, 2), {root: true});
          }
          return Promise.resolve(user);
        },
        (error) => {
          commit('logout');
          return Promise.reject(error);
        }
      );
    }
  },

  mutations: {
    loginSuccess(state, newUser) {
      state.user = newUser;
    },

    logout(state) {
      state.user = null;
    }
  },

  getters: {
    isUserLoggedIn(state) {
      return state.user !== undefined && state.user !== null;
    },

    token(state) {
      return state.user ? state.user.token : null;
    },

    idUser(state) {
      return state.user ? state.user.idUser : null;
    },

    username(state) {
      return state.user ? state.user.username : null;
    },

    userFullName(state) {
      return state.user ? state.user.fullName : null;
    },

    companies(state) {
      return state.user ? state.user.companies : null;
    },

    companySelected(state) {
      return state.user ? state.user.companySelected : null;
    },

    channels(state) {
      return state.user ? state.user.channels : [];
    },

    roles(state) {
      return state.user ? state.user.roles : [];
    }
  }
};
